export const randomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

export const rangeInt = (start: number, end: number): number[] => {
  // @ts-ignore
  return [...Array(end - start + 1).keys()].map((x) => x + start);
};
